import React from "react";
import Button from "../UI/Button";
import classes from "./ProfileComponents.module.scss";

const ProfileDetails = ({ orgTitle, isEditMode, onEditModeHandler }) => {
  const onEditClickHandler = () => {
    onEditModeHandler(true);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-5">
      <h2 className={`pt-2 pb-2 ${classes.title}`}>{orgTitle} - Profile</h2>
      {!isEditMode && (
        <Button className="px-5 py-1" onClick={onEditClickHandler}>
          Edit
        </Button>
      )}
    </div>
  );
};

export default ProfileDetails;
